import { FC } from "react";
import { useTranslation } from "react-i18next";

interface TourNavigationProps {
  currentStep: number;
  totalSteps: number;
  onNext: () => void;
  onPrevious: () => void;
  showPrevious: boolean;
  showNext: boolean;
}

const ArrowIcon: FC<{ direction: "left" | "right"; className?: string }> = ({
  direction,
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    style={{
      transform: direction === "left" ? "rotate(180deg)" : "none",
    }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.29289 0.959397C7.68342 0.568873 8.31658 0.568873 8.70711 0.959397L15.7071 7.9594C16.0976 8.34992 16.0976 8.98309 15.7071 9.37361L8.70711 16.3736C8.31658 16.7641 7.68342 16.7641 7.29289 16.3736C6.90237 15.9831 6.90237 15.3499 7.29289 14.9594L12.5858 9.6665H1C0.447715 9.6665 0 9.21879 0 8.6665C0 8.11422 0.447715 7.6665 1 7.6665H12.5858L7.29289 2.37361C6.90237 1.98309 6.90237 1.34992 7.29289 0.959397Z"
      fill="currentColor"
    />
  </svg>
);

export const TourNavigation: FC<TourNavigationProps> = ({
  currentStep,
  totalSteps,
  onNext,
  onPrevious,
  showPrevious,
  showNext,
}) => {
  const { t, i18n } = useTranslation();

  return (
    <div className="mt-6 flex items-center justify-start gap-4">
      {/* Previous Button */}
      {showPrevious ? (
        <button
          onClick={onPrevious}
          className="flex items-center gap-2 rounded-lg bg-[#232329] px-4 py-4 text-sm font-semibold text-[#EDEAE4] "
        >
          <ArrowIcon direction={i18n.dir() === "ltr" ? "left" : "right"} />
        </button>
      ) : null}

      {/* Next Button */}
      {showNext && (
        <button
          onClick={onNext}
          className="flex items-center gap-2 rounded-lg bg-primary px-4 py-4 text-sm font-semibold text-[#232329] "
        >
          {currentStep === totalSteps - 1 ? t("tour.finish") : t("tour.next")} (
          {currentStep < totalSteps && currentStep + 1 + "/" + totalSteps})
          <ArrowIcon direction={i18n.dir() === "ltr" ? "right" : "left"} />
        </button>
      )}
    </div>
  );
};
